import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL } from './api.config';

export const getApiClient = (typOfApi?: string): AxiosInstance => {
  if (!typOfApi) {
    return apiSearchClient();
  }

  let apiClient: AxiosInstance;
  switch (typOfApi) {
    case 'search':
    default:
      apiClient = apiSearchClient();
      break;
    case 'affiliate':
      apiClient = apiAffiliateClient();
      break;
    case 'mockSearch':
      apiClient = mockApiSearchClient();
      break;
  }
  return apiClient;
};

const apiSearchClient = (): AxiosInstance => {
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-type': 'application/json',
      'cloud-search-api': '40b7b8d3-8f36-4922-a456-efb18fc284e1', // TODO move to env
    },
  });
};

const apiAffiliateClient = (): AxiosInstance => {
  return axios.create({
    headers: {
      'Content-type': 'application/json',
    },
  });
};

const mockApiSearchClient = (): AxiosInstance => {
  return axios.create({
    baseURL: 'http://localhost:5000',
    headers: {
      'Content-type': 'application/json',
    },
  });
};
